import http from '../util/ws/wsService.js'
import EntityServise from './entityService.js';

class ReportService extends EntityServise {
    constructor() {
        super("report")
    }

    async getByRegId(regId) {
        return await http.get(this.routeApi + "/reg", { regId });
    }

}

export default new ReportService();

